import axiosClient from "./axiosClient";

export const category = {
    movie: 'movie',
    tv: 'tv'
}

export const movieType = {
    upcoming: 'upcoming',
    popular: 'popular',
    top_rated: 'top_rated'
}

export const tvType = {
    popular: 'popular',
    top_rated: 'top_rated',
    on_the_air: 'on_the_air'
}

// Sorts videos by resolution, the highest one wins. Official trailers break the
// tie, then the most recent upload.
export const bestQualityVideos = (videos = []) => [...videos]
    .filter((video) => video.site === 'YouTube')
    .sort((a, b) => {
        if ((a.size || 0) !== (b.size || 0)) return (b.size || 0) - (a.size || 0);
        if ((a.type === 'Trailer') !== (b.type === 'Trailer')) return a.type === 'Trailer' ? -1 : 1;
        if (!!a.official !== !!b.official) return a.official ? -1 : 1;
        return new Date(b.published_at || 0) - new Date(a.published_at || 0);
    });

const tmdbApi = {
    getMoviesList: (type, params) => {
        const url = 'movie/' + movieType[type];
        return axiosClient.get(url, params);
    },
    getTvList: (type, params) => {
        const url = 'tv/' + tvType[type];
        return axiosClient.get(url, params);
    },
    getVideos: (cate, id) => {
        const url = category[cate] + '/' + id + '/videos';
        return axiosClient.get(url, {params: {}});
    },
    // Same feed as getVideos, best quality first.
    getBestVideos: (cate, id) => {
        const url = category[cate] + '/' + id + '/videos';
        return axiosClient.get(url, {params: {}}).then((res) => ({
            ...res,
            results: bestQualityVideos(res.results)
        }));
    },
    search: (cate, params) => {
        const url = 'search/' + category[cate];
        return axiosClient.get(url, params);
    },
    detail: (cate, id, params) => {
        const url = category[cate] + '/' + id;
        return axiosClient.get(url, params);
    },
    credits: (cate, id) => {
        const url = category[cate] + '/' + id + '/credits';
        return axiosClient.get(url, {params: {}});
    },
    similar: (cate, id) => {
        const url = category[cate] + '/' + id + '/similar';
        return axiosClient.get(url, {params: {}});
    },
    getGenres: (cate) => {
        const url = 'genre/' + category[cate] + '/list';
        return axiosClient.get(url, {params: {}});
    },
    discover: (cate, params) => {
        const url = 'discover/' + category[cate];
        return axiosClient.get(url, params);
    },
}

export default tmdbApi;